import { refreshKlarna, replaceQueryParam } from '@project/components/utility';
import { ACTIONS } from 'wishlistcustom/product/wishlistHeart';
import { setActiveSlide } from './pdpCarousel';

export function updateWishlistCTA(response) {
    const $wishlistButton = response.container.find('.add-to-wishlist');
    $wishlistButton.attr('data-pid', response.data.product.id);
    $wishlistButton.data('pid', response.data.product.id);
    $wishlistButton.attr('data-wishlist-action', response.data.isInWishlist ? ACTIONS.remove : ACTIONS.add);
    $wishlistButton.data('wishlist-action', response.data.isInWishlist ? ACTIONS.remove : ACTIONS.add);
    $wishlistButton.toggleClass('state-selected', response.data.isInWishlist);
}

export function updateProductLabel(response) {
    const $productLabel = response.container.find('.product-label');
    if ($productLabel.length) {
        const label = response.data.product.productLabel;
        $productLabel.toggleClass('d-none', label);
        $productLabel.find('.product-label__text').text(label);
    }
}

export function updateCta(response) {
    const $ctaContainer = response.container.find('.cart-and-ipay');
    $ctaContainer.toggleClass('already-in-cart', response.data.isInCart);
    $ctaContainer
        .find('.add-to-cart')
        .toggleClass('not-ready', !response.data.product.readyToOrder);
    const backInStockBtn = $ctaContainer.find('.back-in-stock-btn');
    if (backInStockBtn.length) {
        const oldBackAction = backInStockBtn.attr('data-action-url');
        backInStockBtn.attr('data-action-url', replaceQueryParam(oldBackAction, 'pid', response.data.product.id));
    }
}

export function updateColorLabel(response) {
    const newColor = response.data.product.variationAttributes.find(
        (attr) => attr.id === 'color',
    ).displayValue;
    response.container.find('.attribute-color .selected-color').text(newColor);
}

function thumbsHtml(images, dataTarget) {
    return images.map(
        (
            image,
            index,
        ) => `<li class="pdpCarousel-thumbs__dot carousel-thumbs__dot${
            index === 0 ? ' active' : ''
        }" data-index="${index}" data-target="#${dataTarget}">
            <img src="${image.url}" class="hidden-sm-down img-fluid" alt="${
    image.alt
}">
        </li>`,
    );
}

function createThumbnails(imgs, $productContainer) {
    const $thumbs = $productContainer.find('.pdpCarousel-thumbs');
    const carouselId = $($productContainer.find('.carousel')).attr('id');
    $thumbs.html(thumbsHtml(imgs, carouselId));
    setActiveSlide();
}

export function updateImages(response, recreateThumbnails) {
    const primaryImageUrls = response.data.product.images.large;
    if (recreateThumbnails) createThumbnails(primaryImageUrls, response.container);
}

export function updateSocialLinks(response) {
    const { data } = response;
    const $shareLinks = response.container.find('.share-btns .share-links');
    if (!$shareLinks.length) return;
    $shareLinks.each((index, link) => {
        let publicUrlParam;
        switch (link.dataset.share) {
        case 'facebook':
            publicUrlParam = 'u';
            break;
        case 'whatsapp':
            publicUrlParam = 'text';
            break;
        case 'email':
            publicUrlParam = 'body';
            break;
        default:
            publicUrlParam = 'url';
            break;
        }
        let newURL = replaceQueryParam(link.href, publicUrlParam, data.publicUrl);
        if (link.dataset.share === 'pinterest') {
            newURL = replaceQueryParam(replaceQueryParam(newURL, 'media', data.product.images.large[0].absURL), 'description', data.product.productName);
        }
        if (link.dataset.share === 'email') {
            newURL = replaceQueryParam(newURL, 'subject', data.product.productName);
        }
        // eslint-disable-next-line no-param-reassign
        link.href = newURL;
    });
}

function updateUrl(response) {
    const { data } = response;
    if (data?.publicUrl) {
        window.history.replaceState({}, '', data.publicUrl);
    }
}

function updateDescriptionAndDetails(response) {
    const { data, container } = response;
    const $longDescriptionDiv = container.find('.description-and-detail #longDescription');
    if ($longDescriptionDiv && data?.product?.longDescription) {
        $longDescriptionDiv.html(data.product.longDescription);
    }
}

export default function handleVariation(recreateThumbnails = false) {
    $('body').on('product:afterAttributeSelect', (e, response) => {
        updateColorLabel(response);
        updateImages(response, recreateThumbnails);
        const $klarnaElement = response.container.find('klarna-placement');
        let newPrice = response.data.product.price.sales?.value
            || response.data.product.price.list?.value;
        if (newPrice) {
            newPrice = (newPrice * 100).toFixed();
            refreshKlarna($klarnaElement, newPrice);
        }
        updateCta(response);
        updateSocialLinks(response);
        updateWishlistCTA(response);
        updateUrl(response);
        updateDescriptionAndDetails(response);
        updateProductLabel(response);
    });
}
